import * as API from "../framework/api";
import * as Dialog from "../framework/dialog";
import * as Toast from "../framework/components/toast";
import { getUITranslation } from "../utils/get_ui_translation";
import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
  if (!document.querySelector(".js-crm-project-page")) return;

  // All alpines component on the page have access to this store
  Alpine.store("showHidden", false);
});

document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".js-crm-project-page")) return;

  // Alpine helpers

  // Update the conmment of an action card
  async function updateActionComment(action, titleCanBeUpdated, title, comment, lossReasonCanBeUpdated, lossReason) {
    const updateForm = document.querySelector("#edit-business-action-template").content.cloneNode(true);
    updateForm.querySelector("#update-comment-form").action = action;
    if (titleCanBeUpdated) {
      updateForm.querySelector("input[name='business_action[title]']").value = title;
    } else {
      updateForm.querySelector("#title-input").remove();
    }
    if (lossReasonCanBeUpdated) {
      updateForm.querySelector("select[name='customer[customer_loss_reason_id]']").value = lossReason;
    } else {
      updateForm.querySelector("#loss-reason").remove();
    }
    updateForm.querySelector("textarea[name='business_action[comment]']").value = comment;

    const okayed = await Dialog.okCancel(getUITranslation("Modifier l'action"), updateForm);
    if (okayed) {
      let form = document.querySelector("#update-comment-form");
      if (form) form.submit();
    }
  }

  // Tied to the window so it can be used by alpine
  window.updateActionComment = updateActionComment;

  // Hide or reveal an action card
  async function hideComment(action, willBeHidden) {
    const text = willBeHidden
      ? getUITranslation("Êtes-vous sûr de vouloir masquer cette action ?")
      : getUITranslation("Êtes-vous sûr de vouloir révéler cette action ?");

    const okayed = await Dialog.okCancel(
      text,
      `
      <form id="hide-comment-form" action="${action}" class="form-group" method="post">
        <input type="hidden" name="_method" value="PUT" />
        <input type="hidden" name="_csrf_token" value="${API.getCSRFToken()}" />
        <input type="hidden" name="business_action[hidden]" value="${willBeHidden}" />
      </form>
      `
    );

    if (okayed) {
      let form = document.querySelector("#hide-comment-form");
      if (form) form.submit();
    }
  }

  window.hideComment = hideComment;

  const prioritySwitch = document.getElementById("customer-priority");
  if (prioritySwitch) {
    prioritySwitch.addEventListener("change", function (e) {
      e.target.disabled = true;
      API.fetchJSON(p`/ajax/customers/${e.target.dataset.customerId}`, {
        method: "POST",
        body: { customer: { priority: e.target.checked ? 1 : 0 } },
      })
        .then(() => {
          Toast.show(e.target.checked ? "#priority-activated-toast" : "#priority-deactivated-toast");
        })
        .catch(() => {
          Toast.show("#priority-error-toast");
        })
        .finally(() => {
          e.target.disabled = false;
        });
    });
  }
});
